import request from "@/utils/request";

export function getCarouselList() {
  return request({
    url: "/api/web_content/carousel_images/",
    method: "get",
  });
}

export function getActivityContentList() {
  return request({
    url: "/api/web_content/activity_contents/",
    method: "get",
  });
}

export function getAnnouncementList() {
  return request({
    url: "/api/web_content/announcements/",
    method: "get",
  });
}

export function getAnnouncement(id) {
  return request({
    url: "/api/web_content/announcements/" + id + "/",
    method: "get",
  });
}

export function getSponsorList() {
  return request({
    url: "/api/company/sponsors/",
    method: "get",
  });
}

export function getCoachList() {
  return request({
    url: "/api/company/members/",
    method: "get",
  });
}

export function getCoachDetail(id) {
  return request({
    url: "/api/company/members/" + id + "/",
    method: "get",
  });
}

export function getCourseTypeList() {
  return request({
    url: "/api/program/course_types/",
    method: "get",
  });
}

export function getCourseTypeDetail(id) {
  return request({
    url: "/api/program/course_types/" + id + "/",
    method: "get",
  });
}

export function getCompanyProfile() {
  return request({
    url: "/api/company/profile/",
    method: "get",
  });
}

export function getNewsList() {
  return request({
    url: "/api/news/news/",
    method: "get",
  });
}

export function getNewsDetail(id) {
  return request({
    url: "/api/news/news/" + id + "/",
    method: "get",
  });
}

export function getCourtDetail(id) {
  return request({
    url: "/api/location/courts/" + id + "/",
    method: "get",
  });
}
